var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DividerSeparator',{staticClass:"wide"},[_c('Loader'),_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Loading Data")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }